import posthog from 'posthog-js';
import { getEnvironment } from 'src/env/env';

const isProduction = async (): Promise<boolean> => {
  const environment = await getEnvironment();

  return environment.ENVIRONMENT === 'PROD';
};

export const phEvent = async (event: string, options?: Record<string, unknown>): Promise<void> => {
  const isProd = await isProduction();

  if (!isProd) return;

  posthog?.capture(event, options);
};

// Forgets the identified user, in memory as well as in storage. PostHog only runs in production,
// so this does nothing until it has been initialized.
export const phReset = (): void => {
  if (posthog?.__loaded) {
    posthog.reset();
  }
};
